<app-page-panel class="flex-fit"
    [showBackButton]="false"
    iconNameFontAwesome="payments"
    pageTitle="Preissteigerung"    
    [showBackColor]="true"
    [showDetailsButton]="false"
    [showSidepanelButton]="false"
    [showCloseButton]="true"
    [showContent]="false"
    (closeButtonClicked)="onCloseClick()">
</app-page-panel>
<mat-dialog-content class="flex flex-fill">
    <div class="flex flex-fill flex-col flex-stretch-self flex-gap">
        <dx-data-grid fxFill #gridPreissteigerung
            [allowColumnResizing]="true"
            [allowColumnReordering]="true"
            [focusedRowEnabled]="true"
            [hoverStateEnabled]="true"
            [showColumnLines]="true"
            [cellHintEnabled]="true"
            [columnAutoWidth]="false"
            [repaintChangesOnly]="true"
            [rowAlternationEnabled]="false"
            keyExpr="preissteigerungId"
            [noDataText]="''"
            [width]="'100%'" 
            [height]="'104px'"   
            [dataSource]="dataPreissteigerung()"
            (onInitialized)="onGridInitialized($event)"
            (onContentReady)="onGridContentReady($event)"
            (onCellPrepared)="onGridCellPrepared($event)"
            (onRowDblClick)="onGridRowDblClick($event)"
            (onSaving)="onGridRowSaving($event)"
            (onSaved)="onGridRowSaved($event)"
            >       
                <dxi-column dataField="name" caption="Anpassung" dataType="string"  [allowEditing]="false" alignment="left">
                </dxi-column>

                <dxi-column dataField="jahrVergangenheitProzent"  [allowEditing]="false" [caption]="gridService.captionVorjahr()" dataType="number" alignment="right" width="90" format="#0.00%" [editorOptions]="{ format: '#0.00%' }" [setCellValue]="setGridCellValueDefault">
                </dxi-column>
                <dxi-column dataField="jahr0Prozent" [caption]="gridService.captionJahr(0)" dataType="number" alignment="right" width="80" format="#0.00%" [editorOptions]="{ format: '#0.00%', precision: 2}" [setCellValue]="setGridCellValueDefault">
                </dxi-column>
                <dxi-column dataField="jahr1Prozent" [caption]="gridService.captionJahr(1)" dataType="number" alignment="right" width="80" format="#0.00%" [editorOptions]="{ format: '#0.00%' }" [setCellValue]="setGridCellValueDefault">
                </dxi-column>
                <dxi-column dataField="jahr2Prozent" [caption]="gridService.captionJahr(2)" dataType="number" alignment="right" width="80" format="#0.00%" [editorOptions]="{ format: '#0.00%' }" [setCellValue]="setGridCellValueDefault">
                </dxi-column>
                <dxi-column dataField="jahr3Prozent" [caption]="gridService.captionJahr(3)" dataType="number" alignment="right" width="80" format="#0.00%" [editorOptions]="{ format: '#0.00%' }" [setCellValue]="setGridCellValueDefault">
                </dxi-column>
                <dxi-column dataField="jahr4Prozent" [caption]="gridService.captionJahr(4)" dataType="number" alignment="right" width="80" format="#0.00%" [editorOptions]="{ format: '#0.00%' }" [setCellValue]="setGridCellValueDefault">
                </dxi-column>
                <dxi-column dataField="jahr5Prozent" [caption]="gridService.captionJahr(5)" dataType="number" alignment="right" width="80" format="#0.00%" [editorOptions]="{ format: '#0.00%' }" [setCellValue]="setGridCellValueDefault">
                </dxi-column>
                <dxi-column dataField="jahrZukunftProzent" [caption]="gridService.captionJahrFF(6)" dataType="number" alignment="right" width="80" format="#0.00%" [editorOptions]="{ format: '#0.00%' }" [setCellValue]="setGridCellValueDefault">
                </dxi-column>
                <dxi-column dataField="abweichungBegruendung" caption="Begründung" dataType="string" [allowResizing]="false" alignment="center" width="200" headerCellTemplate="abweichungBegruendungHeaderTemplate" cellTemplate="iconCellTemplate" editCellTemplate="abweichungBegruendungEditCellTemplatee" [setCellValue]="setGridCellValueDefault">
                    <dxi-validation-rule type="custom" message="Die Begruendung ist ein Pflichtfeld" [validationCallback]="validateGridAbweichungsbegruendung" [reevaluate]="true"></dxi-validation-rule>
                    <div *dxTemplate="let data of 'abweichungBegruendungHeaderTemplate'">
                        <div class="flex flex-center">
                            <i class="dx-icon-description icon-size-20px"></i>
                            <span>Begründung</span>
                        </div>                        
                    </div>
                    <div *dxTemplate="let cellInfo of 'abweichungBegruendungEditCellTemplatee'">
                        <dx-drop-down-box #dropDownBoxBegruendung *ngIf="isGridEditModeRow()"
                            [showClearButton]="false"
                            [(value)]="cellInfo.value"
                            fieldTemplate="textboxIconFieldTemplate"
                            contentTemplate="abweichungBegruendungContentTemplate">
                            <dxo-drop-down-options
                                pageTitle="Begründung zur Abweichung"
                                width=750
                                [showTitle]="true"
                                [fullScreen]="false"
                                [showCloseButton]="true">
                            </dxo-drop-down-options>
                            <div *dxTemplate="let data of 'textboxIconFieldTemplate'">
                                <div class="flex flex-row flex-center">
                                    @if (data) { 
                                        <!-- <i class="dx-icon-description icon-size-20px"></i> -->
                                        <span>{{data}}</span>
                                    }       
                                    <dx-text-box [width]="0" [readOnly]="true"></dx-text-box>
                                </div>
                            </div>               
                            <div *dxTemplate="let content of 'abweichungBegruendungContentTemplate'">
                                <dx-text-area
                                    [label]="'Begründung'"
                                    [(value)]="cellInfo.value"
                                    [minHeight]="48"
                                    [height]="300"
                                    [autoResizeEnabled]="true"
                                    (onValueChanged)="onGridTextareaValueChanged($event, cellInfo, content.component)">
                                </dx-text-area>
                            </div>
                        </dx-drop-down-box>
                        <dx-text-area *ngIf="!isGridEditModeRow()"
                            labelMode="static"
                            label="Begründung zur Abweichung"
                            [(value)]="cellInfo.value"
                            [height]="48"
                            [autoResizeEnabled]="true"
                            (onValueChanged)="cellInfo.setValue($event.value)">
                        </dx-text-area>
                    </div>
                </dxi-column>
                <dxi-column dataField="" caption="" width="55" alignment="center"></dxi-column>
                <dxi-column type="buttons" [width]="columnWidth()" [fixed]="true" fixedPosition="right" [showInColumnChooser]="false">
                    <dxi-button name="edit" icon="edit" [onClick]="onGridRowEditButtonClick" [visible]="isGridRowEditButtonVisible" ></dxi-button>
                    <dxi-button name="customFormEdit" icon="rowproperties" [onClick]="onGridRowPopupButtonClick" [visible]="isGridRowPopupButtonVisible"></dxi-button>
                </dxi-column>       
                <dxo-column-fixing [enabled]="true"></dxo-column-fixing>           
                <dxo-group-panel [visible]="false" emptyPanelText=""></dxo-group-panel>
                <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
                <dxo-search-panel [visible]="false" [width]="250" placeholder="Ergebnisliste filtern"></dxo-search-panel>
                <dxo-header-filter [visible]="false" search.enabled="false"></dxo-header-filter>                    
                <dxo-filter-row [visible]="false"></dxo-filter-row>
                <dxo-scrolling mode="virtual" preloadEnabled="true" columnRenderingMode="virtual" rowRenderingMode="virtual" useNative="true" ></dxo-scrolling>
                <dxo-grouping [contextMenuEnabled]="false" [autoExpandAll]="true"></dxo-grouping>
                <dxo-selection mode="single"></dxo-selection>
                <dxo-toolbar [visible]="false"></dxo-toolbar>
            <dxo-editing
                mode="row"
                [allowUpdating]="true"
                [allowDeleting]="false"
                [allowAdding]="false"
                [useIcons]="true">
                <dxo-popup
                    title="Preissteigerung | Details"
                    [showTitle]="true"
                    width="1200px"
                    height="400px">
                </dxo-popup>
                <dxo-form [readOnly]="true">
                    <dxi-item itemType="group" [colCount]="6" [colSpan]="2">
                        <dxi-item itemType="group" caption="Leistungsabfluss (%)" [colCount]="8" [colSpan]="6" >                      
                            <dxi-item dataField="jahrVergangenheitProzent" caption="bis 2023" [colSpan]="1"></dxi-item>
                            <dxi-item dataField="jahr0Prozent" caption="2024" [colSpan]="1"></dxi-item>
                            <dxi-item dataField="jahr1Prozent" caption="2025" [colSpan]="1"></dxi-item>
                            <dxi-item dataField="jahr2Prozent" caption="2026" [colSpan]="1"></dxi-item>
                            <dxi-item dataField="jahr3Prozent" caption="2027" [colSpan]="1"></dxi-item>
                            <dxi-item dataField="jahr4Prozent" caption="2028" [colSpan]="1"></dxi-item>
                            <dxi-item dataField="jahr5Prozent" caption="2029" [colSpan]="1"></dxi-item>
                            <dxi-item dataField="jahrZukunftProzent" caption="2030 ff." [colSpan]="1"></dxi-item>
                            <dxi-item itemType="empty" [colSpan]="4"></dxi-item>
                        </dxi-item>
                        <dxi-item itemType="group" caption="Begründungen" [colCount]="6" [colSpan]="6" >                      
                            <dxi-item dataField="abweichungBegruendung" [colSpan]="6"></dxi-item>
                        </dxi-item>

                    </dxi-item>
                </dxo-form>            
            </dxo-editing>            
            <dxo-load-panel [enabled]="true" [showPane]="false"></dxo-load-panel>
            <dxo-paging [enabled]="false"></dxo-paging>            
            <dxo-pager [visible]="false" displayMode="full" [showNavigationButtons]="true" [showPageSizeSelector]="true"></dxo-pager>
            <div *dxTemplate="let data of 'iconCellTemplate'">
                @if (data.value) {
                    <i class="dx-icon-description icon-size-20px"></i>
                }
            </div>

        </dx-data-grid>
        <dx-data-grid fxFill #gridKalkulation
            [allowColumnResizing]="true"
            [allowColumnReordering]="true"
            [focusedRowEnabled]="false"
            [hoverStateEnabled]="true"
            [showColumnLines]="true"
            [cellHintEnabled]="true"
            [columnAutoWidth]="false"
            [repaintChangesOnly]="true"
            [rowAlternationEnabled]="false"
            keyExpr="kostenID"
            [noDataText]="''"
            [width]="'100%'" 
            [height]="'168px'"   
            [dataSource]="dataPreissteigerungKalkulation()"
            >       
            <dxi-column name="bandCaption" caption="Kalkulation">
                <dxi-column dataField="kostengruppe" caption="Kostentyp" dataType="string" [allowEditing]="false" alignment="left">
                </dxi-column>
            </dxi-column>
            <dxi-column name="bandIstKostenProzent" caption="Ist-Kosten">
                <dxi-column dataField= "vorjahr" [caption]="gridService.captionVorjahr()" dataType="number" alignment="right" width="90" format="#,##0€" [editorOptions]="{ format: '#0.00%' }" [allowEditing]="false" >
                </dxi-column>
            </dxi-column>
            <dxi-column name="bandLeistungsabflussProzent" caption="Leistungsabfluss">
                <dxi-column dataField="jahr0" [caption]="gridService.captionJahr(0)" dataType="number" alignment="right" width="80" format="#,##0€" [editorOptions]="{ format: '#0.00%', precision: 2}" [allowEditing]="false">
                </dxi-column>
                <dxi-column dataField="jahr1" [caption]="gridService.captionJahr(1)" dataType="number" alignment="right" width="80" format="#,##0€" [editorOptions]="{ format: '#0.00%' }" [allowEditing]="false">
                </dxi-column>
                <dxi-column dataField="jahr2" [caption]="gridService.captionJahr(2)" dataType="number" alignment="right" width="80" format="#,##0€" [editorOptions]="{ format: '#0.00%' }" [allowEditing]="false">
                </dxi-column>
                <dxi-column dataField="jahr3" [caption]="gridService.captionJahr(3)" dataType="number" alignment="right" width="80" format="#,##0€" [editorOptions]="{ format: '#0.00%' }" [allowEditing]="false">
                </dxi-column>
                <dxi-column dataField="jahr4" [caption]="gridService.captionJahr(4)" dataType="number" alignment="right" width="80" format="#,##0€" [editorOptions]="{ format: '#0.00%' }" [allowEditing]="false">
                </dxi-column>
                <dxi-column dataField="jahr5" [caption]="gridService.captionJahr(5)" dataType="number" alignment="right" width="80" format="#,##0€" [editorOptions]="{ format: '#0.00%' }" [allowEditing]="false">
                </dxi-column>
                <dxi-column dataField="jahr6folgende" [caption]="gridService.captionJahrFF(6)" dataType="number" alignment="right" width="80" format="#,##0€" [editorOptions]="{ format: '#0.00%' }" [allowEditing]="false">
                </dxi-column>
            </dxi-column>
            <dxi-column name="bandSummeProzent" caption="">
                <dxi-column dataField="kosten" caption="Summe" dataType="number" alignment="right" width="100" format="#,##0€" [editorOptions]="{ format: '#0.00 %' }" [allowEditing]="false">
                </dxi-column>
                <dxi-column dataField="rest" caption="Rest" width="85" dataType="number" alignment="right" width="100" format="#,##0€" [editorOptions]="{ format: '#0.00 %' }" [allowEditing]="false">
                </dxi-column>
            </dxi-column>

            <!-- <dxi-column name="bandIstKosten" caption="Ist-Kosten">
                <dxi-column dataField="jahrVergangenheit" [caption]="gridService.captionVorjahr()" dataType="number" alignment="right" width="90" format="#,##0€" [editorOptions]="{ format: '#,##0€' }" [setCellValue]="setGridCellValueDefault">
                </dxi-column>
            </dxi-column>
            <dxi-column name="bandLeistungsabfluss" caption="Leistungsabfluss">
                <dxi-column dataField="jahr0" [caption]="gridService.captionJahr(0)" dataType="number" alignment="right" width="90" format="#,##0€" [editorOptions]="{ format: '#,##0€' }" [setCellValue]="setGridCellValueDefault">
                </dxi-column>
                <dxi-column dataField="jahr1" [caption]="gridService.captionJahr(1)" dataType="number" alignment="right" width="90" format="#,##0€" [editorOptions]="{ format: '#,##0€' }" [setCellValue]="setGridCellValueDefault">
                </dxi-column>
                <dxi-column dataField="jahr2" [caption]="gridService.captionJahr(2)" dataType="number" alignment="right" width="90" format="#,##0€" [editorOptions]="{ format: '#,##0€' }" [setCellValue]="setGridCellValueDefault">
                </dxi-column>
                <dxi-column dataField="jahr3" [caption]="gridService.captionJahr(3)" dataType="number" alignment="right" width="90" format="#,##0€" [editorOptions]="{ format: '#,##0€' }" [setCellValue]="setGridCellValueDefault">
                </dxi-column>
                <dxi-column dataField="jahr4" [caption]="gridService.captionJahr(4)" dataType="number" alignment="right" width="90" format="#,##0€" [editorOptions]="{ format: '#,##0€' }" [setCellValue]="setGridCellValueDefault">
                </dxi-column>
                <dxi-column dataField="jahr5" [caption]="gridService.captionJahr(5)" dataType="number" alignment="right" width="90" format="#,##0€" [editorOptions]="{ format: '#,##0€' }" [setCellValue]="setGridCellValueDefault">
                </dxi-column>
                <dxi-column dataField="jahrZukunft" [caption]="gridService.captionJahrFF(6)" dataType="number" alignment="right" width="90" format="#,##0€" [editorOptions]="{ format: '#,##0€' }" [setCellValue]="setGridCellValueDefault">
                </dxi-column>
            </dxi-column>
            <dxi-column name="bandSumme" caption="">
                <dxi-column dataField="jahrSumme" caption="Summe" dataType="number" alignment="right" width="100" format="#,##0€" [editorOptions]="{ format: '#,##0€' }">
                </dxi-column>
                <dxi-column dataField="rest" caption="Rest" width="85" dataType="number" alignment="right" width="100" format="#,##0€" [editorOptions]="{ format: '#,##0€' }">
                </dxi-column>
            </dxi-column> -->
            <dxi-column name="bandkontrolle" caption="" [fixed]="true" fixedPosition="right" [showInColumnChooser]="false">
                <dxi-column dataField="" caption="" width="55" alignment="center" [allowEditing]="false"></dxi-column>
            </dxi-column>

            <dxi-column type="buttons" [width]="columnWidth()" [fixed]="true" fixedPosition="right" [showInColumnChooser]="false">
                <!-- <dxi-button name="edit" icon="edit" [onClick]="onGridRowEditButtonClick" [visible]="true" ></dxi-button>
                <dxi-button name="customFormEdit" icon="rowproperties" [onClick]="onGridRowPopupButtonClick" [visible]="true"></dxi-button> -->
            </dxi-column>       
            <dxo-column-fixing [enabled]="true"></dxo-column-fixing>           
            <dxo-group-panel [visible]="false" emptyPanelText=""></dxo-group-panel>
            <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
            <dxo-search-panel [visible]="false" [width]="250" placeholder="Ergebnisliste filtern"></dxo-search-panel>
            <dxo-header-filter [visible]="false" search.enabled="false"></dxo-header-filter>                    
            <dxo-filter-row [visible]="false"></dxo-filter-row>
            <dxo-scrolling mode="virtual" preloadEnabled="true" columnRenderingMode="virtual" rowRenderingMode="virtual" useNative="true" ></dxo-scrolling>
            <dxo-grouping [contextMenuEnabled]="false" [autoExpandAll]="true"></dxo-grouping>
            <dxo-selection mode="single"></dxo-selection>
            <dxo-toolbar [visible]="false"></dxo-toolbar>
            <dxo-editing
                mode="row"
                [allowUpdating]="false"
                [allowDeleting]="false"
                [allowAdding]="false"
                [useIcons]="true">
                <!-- <dxo-popup
                    title="Preissteigerung | Details"
                    [showTitle]="true"
                    width="1200px"
                    height="755px">
                </dxo-popup>
                <dxo-form [readOnly]="true">
                    <dxi-item itemType="group" [colCount]="6" [colSpan]="2">
                    
                        <dxi-item itemType="group" caption="Leistungsabfluss (%)" [colCount]="8" [colSpan]="6" >                      
                            <dxi-item dataField="jahrVergangenheitProzent" caption="bis 2023" [colSpan]="1"></dxi-item>
                            <dxi-item dataField="jahr0Prozent" caption="2024" [colSpan]="1"></dxi-item>
                            <dxi-item dataField="jahr1Prozent" caption="2025" [colSpan]="1"></dxi-item>
                            <dxi-item dataField="jahr2Prozent" caption="2026" [colSpan]="1"></dxi-item>
                            <dxi-item dataField="jahr3Prozent" caption="2027" [colSpan]="1"></dxi-item>
                            <dxi-item dataField="jahr4Prozent" caption="2028" [colSpan]="1"></dxi-item>
                            <dxi-item dataField="jahr5Prozent" caption="2029" [colSpan]="1"></dxi-item>
                            <dxi-item dataField="jahrZukunftProzent" caption="2030 ff." [colSpan]="1"></dxi-item>
                            <dxi-item itemType="empty" [colSpan]="4"></dxi-item>
                            <dxi-item dataField="jahrSummeProzent" caption="Summe (%)" [colSpan]="2"></dxi-item>
                            <dxi-item dataField="restProzent" caption="Rest (%)" [colSpan]="2"></dxi-item>
                        </dxi-item>

                        <dxi-item itemType="group" caption="Leistungsabfluss (€)" [colCount]="8" [colSpan]="6" >                      
                            <dxi-item dataField="jahrVergangenheit" caption="bis 2023" [colSpan]="1"></dxi-item>
                            <dxi-item dataField="jahr0" caption="2024" [colSpan]="1"></dxi-item>
                            <dxi-item dataField="jahr1" caption="2025" [colSpan]="1"></dxi-item>
                            <dxi-item dataField="jahr2" caption="2026" [colSpan]="1"></dxi-item>
                            <dxi-item dataField="jahr3" caption="2027" [colSpan]="1"></dxi-item>
                            <dxi-item dataField="jahr4" caption="2028" [colSpan]="1"></dxi-item>
                            <dxi-item dataField="jahr5" caption="2029" [colSpan]="1"></dxi-item>
                            <dxi-item dataField="jahrZukunft" caption="2030 ff." [colSpan]="1"></dxi-item>
                            <dxi-item itemType="empty" [colSpan]="4"></dxi-item>
                            <dxi-item dataField="jahrSumme" caption="Summe" [colSpan]="2"></dxi-item>
                            <dxi-item dataField="rest" caption="Rest" [colSpan]="2"></dxi-item>
                        </dxi-item>

                    </dxi-item>
                </dxo-form>             -->
            </dxo-editing>            
            <dxo-load-panel [enabled]="true" [showPane]="false"></dxo-load-panel>
            <dxo-paging [enabled]="false"></dxo-paging>            
            <dxo-pager [visible]="false" displayMode="full" [showNavigationButtons]="true" [showPageSizeSelector]="true"></dxo-pager>
        </dx-data-grid>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-stroked-button class="mdc-button" (click)="closeClick()">Beenden</button>
</mat-dialog-actions>
